import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//            Отправить запрос на получение следующих страниц с постами
//------------------------------------------------------------------------------
export const getNextPagePosts = async (next) => {
  const url = `${ next }`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try{
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении постов: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch{
    console.error('Ошибка получения постов:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx